import { render, staticRenderFns } from "./HomeShortcuts.vue?vue&type=template&id=e4d83b78"
import script from "./HomeShortcuts.vue?vue&type=script&lang=js"
export * from "./HomeShortcuts.vue?vue&type=script&lang=js"
import style0 from "./HomeShortcuts.vue?vue&type=style&index=0&id=e4d83b78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports